import {useState,useEffect} from 'react'
import clientServices from '../app/client/clientServices';
import { useAlert } from '../context/AlertContext';



function useClientDetails() {

    const [loading,setLoadingStatus] = useState(false);
    const [clientDetails,setClientDetails] = useState(null)
    const {AppAlert} = useAlert()

    const getClientDetails = (clientId) =>{
        if(clientId !== ""){
            setClientDetails(null);
            setLoadingStatus(true);
            clientServices.getById(clientId).then(res=>{
                if(res.data == null ){
                    AppAlert("Invalid Client Id","error")
                }
                setClientDetails(res.data);
            }).catch(error=>{
                AppAlert(error.msg,"error")
            }).finally(()=>{
                setLoadingStatus(false);
            })
        }
    }

     
    

    return [clientDetails,getClientDetails,loading];
}

export default useClientDetails;
